import React, { memo, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Main, Wrapper } from './Layout.styles';

function Layout({ children = null, dataTestId, className = '', ...rest }) {
  const didMountCurrent = useRef();
  const location = useLocation();

  useEffect(() => {
    if (!didMountCurrent.current) {
      if (process.env.NODE_ENV !== 'development') {
        window?.scrollTo(0, 0);
      }
    } else {
      didMountCurrent.current = true;
    }
  }, [location.pathname]);

  return (
    <Wrapper
      data-testid={dataTestId}
      {...rest}
      className={`mfz-page-wrap ${className || ''}`}
    >
      <Main>{children}</Main>
    </Wrapper>
  );
}

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node]),
  stylesWrapper: PropTypes.objectOf(PropTypes.any),
  dataTestId: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default memo(Layout);
